import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareBacklogRoute: InvariantJiraRoute = {
	name: 'software-backlog',
	path: '/jira/software/projects/:projectKey/boards/:boardId/backlog',
};
